import { render, staticRenderFns } from "./DailyVoyageReportBulkTransactionTable.vue?vue&type=template&id=57caa248&"
import script from "./DailyVoyageReportBulkTransactionTable.vue?vue&type=script&lang=js&"
export * from "./DailyVoyageReportBulkTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports